import { useEffect } from 'react';
import { useSearchParams, useNavigation, Form, useActionData, Link } from 'react-router-dom';
import Field from '../components/form/Field.jsx'
import Button from '../components/Button.jsx'
import ReactRecaptcha3 from 'react-google-recaptcha3'
import { RecoverPasswordAccount } from '../repo/AccountsRepo.js';
import { config } from '../config';

export default function AccountPasswordRecover() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || ''
  const responseData = useActionData()
  const passwordRecoveryNavigation = useNavigation()
  const isSubmitting = passwordRecoveryNavigation.state === 'submitting'

  useEffect(() => {
    ReactRecaptcha3.init(config.recaptchaPublicKey).then(status => {
      if (status !== 'success') {
        console.log("Error! Could not load Recaptcha.")
      }
    })
  }, [])

  function successResponse(respData) {
    return (respData && respData.success)
  }

  function tokenHasError(respData) {
    return (respData && respData.errors && respData.errors.detail === 'token is invalid')
  }

  function passwordHasError(respData) {
    if (respData && respData.errors && respData.errors.detail === 'password has an invalid format') {
      return "Mínimo de 8 caracteres com uma letra maíscula, uma minuscula, um número e um caractere especial"
    }

    return ""
  }

  function passwordConfirmationHasError(respData) {
    if (respData && respData.errors && respData.errors.detail === 'password and confirmation password are different') {
      return "Senha e senha de confirmação são diferentes"
    }

    return ""
  }

  return (
    <section>
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <p className="flex items-center mb-6 text-2xl font-semibold text-gray-900">
          Recuperar Senha
        </p>
        <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            {tokenHasError(responseData) &&
            <div className="flex items-center p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50" role="alert">
              <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
              </svg>
              <span className="sr-only">Info</span>
              <div>
                <span className="font-medium">Erro!</span> Há um problema com seu processo de recuperação de senha. Utilize novamente o link que você recebeu em seu email ou faça o processo de recuperação de senha novamente.
              </div>
            </div>
            }

            {!tokenHasError(responseData) && !successResponse(responseData) && (
            <Form method="POST" className="space-y-4 md:space-y-6">
              <div className="flex items-center p-4 mb-4 text-sm text-blue-800 border border-blue-300 rounded-lg bg-blue-50" role="alert">
                <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                </svg>
                <span className="sr-only">Info</span>
                <div>
                  Perto de concluir! Falta apenas escolher uma nova senha para sua conta.
                </div>
              </div>

              <Field type={"password"} name={"password"} id={"password"} label={"Nova senha"} disabled={isSubmitting} required={""} error={passwordHasError(responseData)}/>
              <Field type={"password"} name={"password_confirmation"} id={"password_confirmation"} disabled={isSubmitting} label={"Confirme a nova senha"} required={""} error={passwordConfirmationHasError(responseData)}/>
              <Field type={"hidden"} name={"token"} id={"token"} value={token} required={""} />

              <Button styleName="green" className="w-full" disabled={isSubmitting}>
                {isSubmitting ? 'Concluindo...' : 'Concluir'}
              </Button>
            </Form>
            )}

            {successResponse(responseData) && (
              <>
                <p>Sua senha foi alterada!</p>
                <p>Já é possível fazer <Link to="/sign_in" className="font-medium text-green-600 hover:underline cursor-pointer">login.</Link> com sua nova senha.</p>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

async function getRecaptchaToken() {
  let recaptchaToken = '';

  await ReactRecaptcha3.getToken().then(token => {
    recaptchaToken = token
  }, error => {
    console.log("ERROR!", error)
  })

  return recaptchaToken;
}

export async function action({request}) {
  const data = await request.formData()
  const recaptchaToken = await getRecaptchaToken()

  const requestPasswordRecoveryData = {
    password: data.get('password'),
    password_confirmation: data.get('password_confirmation'),
    token: data.get('token'),
    captcha_token: recaptchaToken
  }

  return await RecoverPasswordAccount(requestPasswordRecoveryData)
}
